import { promoteFocusSet, getSetCounts } from "@/lib/scheduler";
import { NextRequest, NextResponse } from "next/server";

export async function POST(request: NextRequest) {
  try {
    const body = await request.json();
    const { userId } = body;

    if (!userId) {
      return NextResponse.json(
        { error: "userId is required" },
        { status: 400 }
      );
    }

    // Promote Focus set: move all Focus → Old, grab next 20 from New → Focus
    const newFocusCount = await promoteFocusSet(userId);

    // Get updated counts
    const counts = await getSetCounts(userId);
    const masteryPercent = counts.focusCount > 0
      ? Math.round((counts.focusCorrectCount / counts.focusCount) * 100)
      : 0;

    return NextResponse.json({
      success: true,
      newFocusCount,
      focusCount: counts.focusCount,
      focusCorrectCount: counts.focusCorrectCount,
      masteryPercent,
      newCount: counts.newCount,
      oldCount: counts.oldCount,
    });
  } catch (error) {
    console.error("Error promoting focus set:", error);
    return NextResponse.json(
      { error: error instanceof Error ? error.message : "Failed to promote focus set" },
      { status: 500 }
    );
  }
}
